import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/products/Products";
import Contact from "./pages/Contact";
import AutomatedMachinery from "./pages/products/AutomatedMachinery";
import ElectricalAutomotive from "./pages/products/ElectricalAutomotive";
import ConsumerTechPlastics from "./pages/products/ConsumerTechPlastics";
import MetalFabricationAssembly from "./pages/products/MetalFabricationAssembly";
import MainLayout from "./layouts/MainLayout";
import Gallery from "./pages/Gallery";
import QualityAssurance from "./pages/QualityAssurance";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./pages/NotFound";

const App = () => {
    return (
        <>
            <ScrollToTop />
            <Routes>
                {/* All routes wrapped with MainLayout */}
                <Route element={<MainLayout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/products/:category/:type" element={<Products />} />
                    <Route path="/electricalAutomotive" element={<ElectricalAutomotive />} />
                    <Route path="/metalFabricationAssembly" element={<MetalFabricationAssembly />} />
                    <Route path="/automatedMachinery" element={<AutomatedMachinery />} />
                    <Route path="/consumerTechPlastics" element={<ConsumerTechPlastics />} />
                    <Route path="/gallery" element={<Gallery />} />
                    <Route path="/qualityAssurance" element={<QualityAssurance />} />
                    <Route path="/contact" element={<Contact />} />
                </Route>
                {/* 404 route */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </>
    );
}

export default App;
